export const DAZOS_URL =
  "https://houseoflife.dazoshealth.com/crm/modules/Webforms/capture.php";
export const DAZOS_ASSIGNED = 9992;
export const DAZOS_PUBLIC_ID_INSURANCE_FORM =
  "7cecc8c2d13095f3d9ee408b18ff515d";
export const DAZOS_PUBLIC_ID_CONTACT_FORM = "cc4c4550aeafab8b2deb145b35075c16";
